<template>
    <a class="relative block overflow-hidden group bg-black" :href="product.roam_products_url">
        <img
            class="object-cover object-center w-full h-full max-h-full group-hover:opacity-75 lazyload"
            :data-srcset="image"
            data-sizes="(min-width: 1024px) 290px, 100vw"
            :alt="product.title"
            width="328"
            height="400"
        />

        <div class="absolute inset-0 transition-opacity duration-150 transform bg-gradient-dark">
            <div
                class="flex flex-col justify-end items-center h-full p-8 transition-transform duration-150 transform translate-y-20 group-hover:translate-y-0"
            >
                <div class="text-center">
                    <div
                        v-if="dates(product.roam_products_eventDates)"
                        class="inline-block px-3 py-1 text-xs text-white bg-blue-500 rounded-full mb-2"
                    >
                        {{ dates(product.roam_products_eventDates) }}
                    </div>

                    <span
                        v-if="category"
                        class="text-xs uppercase font-bold text-white font-heading uppercase tracking-medium mb-3 block"
                    >
                        <svg
                            class="block mb-2 mx-auto"
                            width="14"
                            height="13"
                            viewBox="0 0 14 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7 0.629776L8.63949 3.95175C8.78515 4.24689 9.06672 4.45146 9.39243 4.49879L13.0584 5.03149L10.4057 7.61729C10.17 7.84702 10.0625 8.17802 10.1181 8.50242L10.7443 12.1536L7.46534 10.4298C7.17402 10.2766 6.82598 10.2766 6.53466 10.4298L3.25568 12.1536L3.88191 8.50242C3.93754 8.17803 3.83 7.84702 3.59431 7.61729L0.941558 5.03149L4.60757 4.49879C4.93328 4.45146 5.21485 4.24689 5.36051 3.95175L7 0.629776Z"
                                stroke="white"
                                stroke-miterlimit="4.62023"
                                stroke-linecap="round"
                            />
                        </svg>
                        {{ category }}
                    </span>
                    <h3 class="h4 text-white">{{ product.title }}</h3>

                    <a
                        class="btn btn-primary mt-8 transition-all duration-500 opacity-0 group-hover:opacity-100"
                    >
                        View
                    </a>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
import moment from 'moment';
import { truncate } from 'lodash';

export default {
    props: {
        product: {
            type: Object,
            required: true
        }
    },

    computed: {
        image() {
            if (this.product.roam_products_images.length) {
                return (
                    this.product.roam_products_images &&
                    this.product.roam_products_images.join(', ')
                );
            } else {
                return 'https://assets.australiascoralcoast.com/images/Francois-Peron-National-Park-1.jpg?auto=compress&fit=clip&fm=webp&q=80&ratio=16%3A9&&w=640';
            }
        },

        category() {
            return this.product['roam_products_categories.lvl0'][0] ?? null;
        }
    },

    methods: {
        trunc(string) {
            return truncate(string, { length: 100, seperator: '&hellip;' });
        },

        dates(dates) {
            if (!dates) return null;
            const now = moment();
            let from = moment.unix(dates[0]);
            if (this.product.roam_products_next_event) {
                from = moment.unix(this.product.roam_products_next_event);
            }
            const to = moment.unix(dates[dates.length - 1]);

            let fromFormatted = from.format('MMM D, YYYY');
            if (now > from) fromFormatted = now.format('MMM D, YYYY');

            return from.isSame(to, 'day')
                ? fromFormatted
                : `${fromFormatted} - ${to.format('MMM D, YYYY')}`;
        }
    }
};
</script>
